/**
 * The API already scopes the grid (admin = everyone, consultant = selected team).
 * Do not re-filter by the logged-in consultant: that hid teammates on the client.
 */
export function getVisibleTeamConsultants<TConsultant>(
  consultants: TConsultant[] | null | undefined
): TConsultant[] {
  return Array.isArray(consultants) ? [...consultants] : [];
}

export function getVisibleTeamSchedules<TSchedule>(
  schedules: TSchedule[] | null | undefined
): TSchedule[] {
  return Array.isArray(schedules) ? schedules : [];
}

export function getVisibleTeamSearchItems<TSearchItem>(
  items: TSearchItem[] | null | undefined
): TSearchItem[] {
  return Array.isArray(items) ? items : [];
}

export function findScheduledSlotsForCoord<
  T extends { date: string; consultant_id: number; status: number }
>(
  schedules: T[],
  scheduleCoord: string,
  scheduledStatus: number
): T[] {
  const [datePart, timePart, consultantId] = scheduleCoord.split("|");
  if (!datePart || !timePart || consultantId == null || consultantId === "") {
    return [];
  }

  const timeStr = `${timePart}:00`;
  const consultant = Number(consultantId);

  return schedules.filter(
    (item) =>
      item.date.startsWith(datePart) &&
      item.date.includes(timeStr) &&
      item.consultant_id === consultant &&
      item.status === scheduledStatus
  );
}
